<template>
  <b-container class="h-100 w-100 bg-white py-3 card-loki">
    <b-row>
      <b-col cols="12" class="w-100">
        <h3 class="f-default">
          <span>{{data.number}}</span>
          <img :src="data.image" alt="" class="float-right" height="45" />
        </h3>
        <p class="f-default mb-0">{{data.title}}</p>
      </b-col>
      <button :style="data.style"></button>
    </b-row>
  </b-container>
</template>
<script>
export default {
    props:{
        data:{
            type:Object
        }
    }
};
</script>
<style lang="scss">
.card-loki {
position: relative;
 overflow: hidden;
  border-radius: 5px;
  // border: 1px solid #c3c3c3;
  // box-shadow: 5px 5px 10px #d3d3d3;
    img,h3,p{
        z-index: 2;
        position: relative;
    }
  button {
  
    position: absolute;
    right: 0;
    bottom: 0;
    height: 30px;
    width: 30px;
    border: none;
    border-radius: 100% 0 0;
     transition: all 0.3s ease;
     z-index: 1;
    &:hover{
        transform: scale(10);
    }
  }
}
</style>